var _defs, _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZoomBig(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .a {\n                fill: none;\n            }\n\n            .b,\n            .c,\n            .d {\n                fill: #fff;\n            }\n\n            .b,\n            .d {\n                opacity: 0.3;\n            }\n\n            .d {\n                fill-rule: evenodd;\n            }\n        "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 48,
    height: 48
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M14.586,18.414a2,2,0,1,1,2.828-2.828l8,8a2,2,0,0,1-2.828,2.828Z",
    transform: "translate(14 15)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M18,28A10,10,0,1,0,8,18,10,10,0,0,0,18,28Zm0,4A14,14,0,1,1,32,18,14,14,0,0,1,18,32Z",
    transform: "translate(4 4)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M12,12V10a1,1,0,0,1,2,0v2h2a1,1,0,0,1,0,2H14v2a1,1,0,0,1-2,0V14H10a1,1,0,0,1,0-2Z",
    transform: "translate(9 9)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomBig);
export default __webpack_public_path__ + "static/media/zoom-big.06762e06bec592390d4f835ce9ae7088.svg";
export { ForwardRef as ReactComponent };